module.exports = __webpack_public_path__ + "static/media/menuList.7d58dfec.svg";